import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { isWithinInterval } from "date-fns";
import { Users } from "lucide-react";

interface TeamMember {
  id: number;
  employee: {
    name: string;
    role: string;
  };
  hourly_rate: number;
  currency: string;
  start_date: Date;
  end_date: Date;
}

interface TeamMembersCardProps {
  assignments: TeamMember[];
  projectType?: 'fixed_price' | 'time_materials';
}

export function TeamMembersCard({ assignments, projectType }: TeamMembersCardProps) {
  // Filter assignments to only show current ones
  const currentAssignments = assignments?.filter(assignment => {
    const now = new Date();
    return isWithinInterval(now, { start: assignment.start_date, end: assignment.end_date });
  }) || [];

  const showRates = projectType === 'time_materials';

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users className="h-5 w-5" />
          Team Members
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Role</TableHead>
              {showRates && <TableHead>Rate</TableHead>}
            </TableRow>
          </TableHeader>
          <TableBody>
            {currentAssignments.length === 0 ? (
              <TableRow>
                <TableCell colSpan={showRates ? 3 : 2} className="text-center text-muted-foreground">
                  No team members currently assigned
                </TableCell>
              </TableRow>
            ) : (
              currentAssignments.map((assignment) => (
                <TableRow key={assignment.id}>
                  <TableCell>{assignment.employee?.name}</TableCell>
                  <TableCell>{assignment.employee?.role}</TableCell>
                  {showRates && (
                    <TableCell>
                      {assignment.hourly_rate} {assignment.currency}/hr
                    </TableCell>
                  )}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}